import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../../reducers";
import { bindActionCreators } from "redux";

import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import useNotaCredito from "../../../../actions/nota-credito.actions";

import InputForm from "../InputFormV2";
import BasicCardDocumentos from "../BasicCardDocumentos";
import { Pagination } from "../../../../components/Pagination";

import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import { BannerElegirSucursal } from "../../../../components/Banner/BannerElegirSucursal";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import InputChips from "../InputChips";
import useUtilsDocs, { processDetalleImpuestosHTML } from "../../../../actions/utils-documentos.actions";
import ObservacionesDocumentoBase from "../../../../components/ObservacionesDocumento/ObservacionesDocumento";
import { NOTA_CREDITO_TYPES } from "../../../../constants/nota-credito.types";

export default function FormulariosNC () {
    const dteCode = "05";
    const {fecha_actual} = useSelector((state: State) => state.general)
    const {formCliente, formProducto, errorsCliente, errorsProducto, productos, totalOriginal, formObservaciones} = useSelector((state: State) => state.notaCredito)
    const {DetallesDTE: {receptor, identificacion}, TipoContribuyenteReceptor} = useSelector((state: State) => state.historial.activeFactura);
    const {departamentos, municipios, actividadesEconomicas, unidadesMedida, datosEmisor, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)

    const dispatch = useDispatch();
    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {getFechaHora, validateHorarioSucursal, validateUsoModulo} = bindActionCreators(actionGeneral, dispatch)
    
    const {processOtrosImpuestosCalculo, procesOtrosImpuestosResumen} = useUtilsDocs();

    const {
        cargarDatosIniciales,
        cargarProductosIniciales,
        cargarSucursales,
 
        actionButton_editar,
        actionButton_eliminarProducto,
        setTotalOriginalNota,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,

        onChangeFormCliente,
        validateFormProducto,
        onChangeFormProducto,
    } = useNotaCredito()
    
    const handleBlurFormProducto = (e: any) => {
        validateFormProducto(e.target.name, e.target.value)
    }

    const handleChangeFormProducto = (e: any) => {
        onChangeFormProducto(e.target.name, e.target.value)
    }

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const receptorGranContribuyente = TipoContribuyenteReceptor === 'true'

    let sumaOperaciones = 0
    let iva = 0
    let subtotal = 0
    let ivaPercibido = 0
    let ivaRetenido = 0
    let retencionRenta = 0
    let total = 0
    let otrosImpuestos = 0
    let resumenTributos:Array<any> = [];

    productos.forEach((producto) => {
        let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
        let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
        let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

        const precio = (precioUnitario * parseFloat(producto.cantidad)) - descuento;
        sumaOperaciones += precio;
        otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
        resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);

        if(!producto.exento){
            iva += ivaProducto
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
        } else {
            subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
        } 
    })
    
    resumenTributos.forEach((resum) => {
        resum.valor = parseFloat(resum.valor.toFixed(2));
    });

    if(emisorGranContribuyente && !receptorGranContribuyente && sumaOperaciones >= 100){
        ivaPercibido = sumaOperaciones * 0.01
    }

    if(!emisorGranContribuyente && receptorGranContribuyente && sumaOperaciones >= 100){
        productos.forEach((producto) => {
            if (!producto.exento) {
                ivaRetenido += (parseFloat(producto.precio) * 0.01) * parseFloat(producto.cantidad)
            }
        })
    }

    subtotal += otrosImpuestos;
    total = subtotal + ivaPercibido - ivaRetenido - retencionRenta

    useEffect(() => {
        validateUsoModulo('/history-invoice?reload=0')
        validateHorarioSucursal('', '/history-invoice?reload=0')
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        cargarProductosIniciales()
        getFechaHora();
    }, [])

    const [tableProductos, setTableProductos] = useState(productos)
    useEffect(() => {
        setTableProductos(productos)
    }, [productos])


    useEffect(() => {
        if (!totalOriginal) {
            setTotalOriginalNota(total);
        }
    }, [total])

    return(
        <>
            <BannerElegirSucursal />
            <div style={{width: '100%'}}>
                <div className='card w-form' style={{textAlign: 'center'}}>
                    <label className="card-title" style={{fontSize: '20px'}}>DOCUMENTO DE REFERENCIA</label>
                    <p style={{margin: 0}}>{identificacion?.numeroControl ?? "---"}</p>
                </div>   
            </div>
            <div className="otros-documentos-container">
                <div className='dos-columnas-resp'>
                <div className='form-content'>
                <BasicCardDocumentos title="Datos del cliente">
                        <InputForm disabled={true} required name = 'granContribuyente' label = 'Gran contribuyente' type = 'checkbox' value = {receptorGranContribuyente} />
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date' value = {fecha_actual?.FechaInput}/>
                        <InputForm disabled={true} required name = 'noDocumento' placeholder = 'NIT' label = 'NIT' type = 'text' value = {receptor?.nit} />
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} maxLength = {50} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {receptor?.nombre} />
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} required options = {departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'departamento' placeholder = 'Departamento' label = 'Departamento' type = 'select' value = {receptor?.direccion?.departamento} />
                        <InputForm disabled={true} required options = {municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'municipio' placeholder = 'Municipio' label = 'Municipio' type = 'select' value = {receptor?.direccion?.municipio} />
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} maxLength = {60} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {receptor?.direccion?.complemento} /> 
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputChips disabled={true} maxChips={5} chips={formCliente.chipsEmail} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {receptor?.correo} />
                        {/* <InputForm disabled={true} maxLength = {50} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {receptor?.correo} /> */}
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {receptor?.codActividad} />
                        <InputForm disabled={true} required name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {receptor?.telefono} />
                    </div>
                    <div className='w-layout-hflex h-inputs'>
                        <div className='label-input'>
                        <InputForm disabled={true} maxLength = {14} required = {formCliente.tipoDocumento === '36'} name = 'nrc' placeholder = 'NRC' label = 'NRC' type = 'text' value = {receptor?.nrc} />
                        </div><div className='label-input'></div>
                    </div>    
                </BasicCardDocumentos>
                </div> 
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
                <BasicCardDocumentos title="Sucursal y serie" style={{height: 'fit-content'}}>
                    <div className='w-layout-hflex h-inputs'>
                        <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)} error = {errorsCliente.sucursal} />
                        <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)} />
                    </div>
                    <div>
                      <h3 className="card-title">Descuentos</h3>
                    </div>
                    <hr className="separador"/>
                    <InputForm autoComplete={'off'} maxLength = {100} onBlur = {handleBlurFormProducto} required name = 'descripcion' placeholder = 'Descripción' label = 'Descripción' type = 'text' value = {formProducto.descripcion} error = {errorsProducto.descripcion} onChange = {handleChangeFormProducto}/>
                    <div className="cf-row-inputs">
                        <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'precio' placeholder = '$0.00' label = 'Precio' type = 'text' value = {formProducto.precio} error = {errorsProducto.precio} onChange = {handleChangeFormProducto}/>
                    </div>
                    <div className="cf-calculos-producto">
                        <div className="w-layout-hflex button-actions">
                            <button className="button transparent" onClick={button_onClickLimpiarFormProducto}>Limpiar</button>
                            <button className="button" onClick={button_onClickAgregarProducto}>Agregar</button>
                        </div>
                  </div>
                </BasicCardDocumentos>
                </div>
                </div>
            </div>
            <div className="w-100">
                <div className="w-layout-layout bill-section wf-layout-layout">               
                <BasicCardDocumentos title="Detalle de productos o servicios" style={{maxWidth: "100%", boxShadow: "none"}}>
                    <div className="tab-plane">
                        <div className="table-facturacion-resp">
                        <table className="table-main-responsive responsive-table-main td-left table-pointer">
                            <thead>
                                <tr>
                                    <td>Cantidad</td>
                                    <td>Unidad de medida</td>
                                    <td>Tipo</td>
                                    <td>Descripción</td>
                                    <td>Precio unitario</td>
                                    <td>Otros impuestos</td>
                                    <td>Descuento</td>
                                    <td>Ventas gravadas</td>
                                    <td>Ventas exentas</td>
                                    <td>Acciones</td>
                                </tr>
                            </thead>
                            <tbody>
                                {tableProductos.map((producto, index) => {
                                    let precioUnitario = 0
                                    let descuento = 0
                                    let gravadas = 0
                                    let exentas = 0
                                    let detalleTributos = ''

                                    precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                                    descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (parseFloat(producto.descuento)/100*precioUnitario) * parseFloat(producto.cantidad) : parseFloat(producto.descuento) 
                                    gravadas = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                    exentas = (precioUnitario * parseFloat(producto.cantidad)) - descuento  
                                    detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '05', producto, gravadas);

                                    return(
                                    <tr key={index}>
                                        <td data-label="Cantidad">{producto.cantidad}</td>
                                        <td data-label="Unidad de medida">{unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                        <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                        <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                        <td data-label="Precio unitario">
                                            {precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}
                                        </td>
                                        <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                        <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label="Ventas gravadas">{!producto.exento ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                        <td data-label="Ventas exentas">{producto.exento ? (isNaN(exentas) ? '$0.00' : exentas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                        <td data-label="Acciones">
                                            <button onClick={() => actionButton_editar(producto)}><img src={EditIcon}/></button>
                                            <button onClick={() => actionButton_eliminarProducto(producto.id)}><img src={DeleteIcon}/></button>
                                        </td>
                                    </tr>
                                )})}
                            </tbody>
                        </table>
                        </div>
                        <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                        <div className="cf-calculos-producto">
                            <table>
                                <tbody>
                                    <tr className="cf-subtotal">
                                        <td>Suma de operaciones</td>
                                        <td>{sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Impuesto al Valor Agregado 13%</td>
                                        <td>{iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Otros impuestos</td>
                                        <td>{otrosImpuestos.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>Subtotal</td>
                                        <td>{(subtotal).toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA percibido 1%</td>
                                        <td>{ivaPercibido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-subtotal">
                                        <td>IVA retenido 1%</td>
                                        <td>{ivaRetenido.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-descuento">
                                        <td>Retencion renta 10%</td>
                                        <td>{retencionRenta.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-total">
                                        <td>Total</td>
                                        <td>{total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                    <tr className="cf-total" style={{opacity: 0.5}}>
                                        <td>Total original</td>
                                        <td>{totalOriginal?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </BasicCardDocumentos>
                </div>
            </div>
            <div className="otros-documentos-container">
                <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
                    <ObservacionesDocumentoBase formObservaciones={formObservaciones} onChange={(field, value) => dispatch({ type: NOTA_CREDITO_TYPES.NC_FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })} />
                    <DocumentosReceptor />
                </div>
            </div>
        </>
    )
}